import Link from "@whoppah/next/link";

import Image from "@/components/common/Image";

type HeaderMobileCategoriesButtonProps = {
  url: string;
  icon?: string | null;
  label: string;
};

export const HeaderMobileCategoriesButton = ({
  url,
  icon,
  label,
}: HeaderMobileCategoriesButtonProps) => {
  return (
    <Link
      href={url}
      className="flex min-w-0 flex-1 basis-0 flex-col items-center space-y-1"
    >
      {!!icon && (
        <div className="relative h-8 w-full">
          {/*
           * The strip sits directly above the hero, the mobile LCP element, and
           * is server-rendered, so its icons would otherwise be fetched at the
           * same priority as the hero image.
           */}
          <Image src={icon} alt={label} layout="fill" fetchPriority="low" />
        </div>
      )}
      <span className="line-clamp-2 w-full hyphens-auto break-words text-center font-title text-[0.6875rem] leading-tight">
        {label}
      </span>
    </Link>
  );
};
